/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext } from 'react';
import { QuizContext } from '../Helpers/Contexts';
import "../App.css";
import Info from './Info';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { useHiddenQuestions } from '../hooks/api.hooks';
import HomeButton from './HomeButton';

export default function Hidden() {
    const {setGameState, setHiddenQuestions } = useContext(QuizContext);
    const { gameId } = useParams();
    const hiddenQuestions = useHiddenQuestions(gameId);
    

    if(!gameId){
        return <p> Invalid url </p>;
    }


    const ListItem = (props) => {
        return (
            <li className='listItem' id={'id'+props.p.MarkedQuestion.created_at}>{props.p.Question.title}
                <button className='show-starred-optionlist' id={props.p.MarkedQuestion.id+props.p.MarkedQuestion.created_at+props.p.MarkedQuestion.question_id+'button'} onClick={() => {
                    showOptions(props.p.MarkedQuestion.id+props.p.MarkedQuestion.created_at+props.p.MarkedQuestion.question_id)
                }}>Näytä</button>
                <ul className='starred-optionlist' style={{display: "none"}} id={props.p.MarkedQuestion.id+props.p.MarkedQuestion.created_at+props.p.MarkedQuestion.question_id}>
                <li><b>A:</b> {props.p.Question.choice_options[0].answer}</li>
                <li><b>B:</b> {props.p.Question.choice_options[1].answer}</li>
                <li><b>C:</b> {props.p.Question.choice_options[2].answer}</li>
                <li><b>D:</b> {props.p.Question.choice_options[3].answer}</li>
                </ul>
                <button className='delStar' onClick={() => {
                    deleteHidden(props.p);
                }}>X</button>
            </li>
        )
    }

    let hiddenList = hiddenQuestions.map((hiddenQuestions) =>
        <ListItem p={hiddenQuestions} key={hiddenQuestions.MarkedQuestion.id+hiddenQuestions.MarkedQuestion.created_at.toString()}/>
    );

    const showOptions = (x) => {
        let list = document.getElementById(x);
        let btn = document.getElementById(x+'button');
        // This is a bad practice this should be refactored to use state
        if (list.style.display === 'none') {
            list.style.display = 'block';
            btn.textContent = 'Sulje';
        } else {
            list.style.display = 'none';
            btn.textContent = 'Näytä';
        }
    }

    const deleteHidden = (x) => {
        axios.delete("/questions/marked/"+x.MarkedQuestion.id).then((res) => {
            if(res.status === 200){
                let newHiddenQuestions = hiddenQuestions.filter((hiddenQuestions) => hiddenQuestions.MarkedQuestion.id !== x.MarkedQuestion.id);
                setHiddenQuestions(newHiddenQuestions);    
            }else{
                alert("Virhe tapahtui kysymyksen poistamisessa!");
            }
        });
    }

    return (
        <div className='component'>
            <HomeButton gid={gameId}/>
            <h3 className='header3'>Piilotetut kysymykset</h3>
            <Info/>
            {hiddenList.length === 0 ? (
                <p style={{padding: '20px'}}>Et ole vielä piilottanut kysymyksiä.</p>
            ):(
                <ul className='qList'>
                    {hiddenList}
                </ul>
            )}
            <Link to={`/game/${gameId}/settings`}>
                <button className='back' onClick={() => {
                    setGameState('settings')}
                }>Takaisin</button>
            </Link>
        </div>
    );
}